<template>
    <form id="retail-locator-form" class="container">
        <div class="field">
            <label class="visuallyhidden" for="zip">Zip Code</label>
            <input type="text" placeholder="Zip Code" v-model="store.zip" name="zip" id="zip" pattern="[0-9]*" inputmode="numeric"/>
            <button @click.prevent="store.getLocations(true)" :class="btnclass" class="btn" :disabled="store.searching">
                Search
            </button>
        </div>
        <span class="or">
            or
        </span>
        <button @click.prevent="store.geoLocate" class="btn ghost white" :disabled="store.searching">Use Current Location</button>
    </form>
</template>
<script setup>

import { useRetailersStore } from '@stores/retailers';
const store = useRetailersStore();

const props = defineProps(['btnclass'])

</script>
